import React from "react";

import numeral from "numeral";
import { Progress } from "reactstrap";

const CstmProgress = ({ step }) => {
  const value = step / 8;

  return <Progress value={value * 100}>{numeral(value).format("0%")}</Progress>;
};

export default CstmProgress;



// WEBPACK FOOTER //
// ./src/components/CstmProgress.js